exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".title-tips[data-v-68da5b01]{padding-bottom:10px;color:#333}.title-tips span[data-v-68da5b01]{margin-right:14px;color:#999}", ""]);

// exports
